import type { JSX } from 'react'

export const BurgerIcon = (): JSX.Element => (
  <use href='#burgerIcon' height='100%' width='100%' />
)
